module.exports = __webpack_public_path__ + "img/compare-active.711c2ba7.svg";